import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import request from '../../services/Request';
import MaterialTable from 'material-table';
import BackButton from '../items/buttons/BackButton';
import LoadingIcon from '../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import { userLimits } from '../dashboard/uitls/userLimits';
import { useHistory } from 'react-router-dom';

const getAllCateURL = `/machines/getFilteredCategroy/`;
const addCategoryToMachineURL = `/machines/updateCategory`;
const getMachineURL = `/machines/edit/`;

export default function AddCategoryToMachine(props) {
  const { filterd } = useContext(UserContext);
  const history = useHistory();
  const { id, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    '',
    'edit_machine'
  );
  const machineID = props.match.params.id != 'all' ? props.match.params.id : null;

  const [allCates, setAllCates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [machine, setMachine] = useState(null);
  const [reflesh, setReflesh] = useState(false);
  const [title, setTitle] = useState('');

  useEffect(() => {
    // 检查 filterd 是否存在且不为空，如果为空则重定向到 viewMyMachines
    if (!machineID && (!filterd || filterd.length === 0)) {
      console.log('No machines selected, redirecting to viewMyMachines');
      history.push('/dashboard/viewMyMachines');
      return;
    }

    let machineURL1 = machineID ? machineID : filterd[0]._id;

    if (machineID) {
      const getMachine = async () => {
        await request({
          method: 'get',
          url: getMachineURL + machineURL1,
        }).then((res) => {
          setMachine(res.data);
        });
      };
      getMachine();
    } else {
      let string = '';
      if (filterd && filterd.length > 0) {
        filterd.forEach((e) => {
          string += e.name + ', ';
        });
        string = string.substring(0, string.length - 2);
      }
      setTitle(string);
    }

    const getCates = async () => {
      await request({
        method: 'get',
        url: getAllCateURL + machineURL1,
      }).then((res) => {
        let cate0 = res.data[0];
        let cate1 = res.data[1];

        cate0.forEach((e) => {
          e.name = e.name?.en;
        });

        cate1.forEach((e) => {
          e.name = e.name?.en;
        });

        const checkedCate = res.data[0];
        checkedCate.forEach((e) => (e.tableData = { checked: true }));
        const cate = res.data[0].concat(res.data[1]);

        setAllCates(cate);
        setLoading(true);
      });
    };
    getCates();

    return () => {
      setAllCates([]);
      setMachine(null);
    };
  }, [reflesh]);

  const addCategory = async (data) => {
    const cateIDs = data.length !== undefined ? data.map((cate) => cate._id) : [];
    await request({
      method: 'post',
      url: addCategoryToMachineURL,
      data: {
        machineID: machineID ? new Array(machineID) : (filterd?.map((e) => e._id) || []),
        ids: cateIDs,
      },
    }).then((res) => {
      Swal.fire({
        text: `The category has been successfully updated`,
        icon: 'success',
        target: document.getElementById('swal2-container'),
      });
      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const columns = [
    {
      title: 'Picture',
      field: 'categoryPicture',
      editable: 'never',
      render: (rowData) => (
        <img
          src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.categoryPicture}/${id}`}
          style={{ width: 200 }}
        />
      ),
    },
    { title: 'Category Name', field: 'name' },
  ];

  // 如果没有机器ID且 filterd 为空，显示加载状态（等待重定向）
  if (!machineID && (!filterd || filterd.length === 0)) {
    return <LoadingIcon />;
  }

  return (
    <div>
      {machine ? (
        <h4
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '80%',
          }}
        >
          Update Categories for the Machine: {machine.name}
        </h4>
      ) : (
        <h4
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '80%',
          }}
        >
          Update Categories for the Machines: {title}
        </h4>
      )}

      {!loading ? (
        <LoadingIcon />
      ) : (
        <div style={{ maxWidth: '100%' }}>
          <MaterialTable
            columns={columns}
            data={allCates}
            title="Add Categories To the Machine"
            // editable={
            //   role === "Admin" &&
            //   {
            //   onRowUpdate: (newData, oldData) =>
            //   new Promise((resolve, reject) => {
            //     setTimeout(() => {
            //       resolve();
            //     }, 1000)
            //   }),
            // }}
            options={{
              actionsColumnIndex: -1,
              selection: true,
            }}
            actions={[
              access && {
                tooltip: 'Save My changes',
                icon: 'save',
                onClick: (evt, data) => {
                  addCategory(data);
                },
              },
              access && {
                tooltip: 'Save My changes',
                icon: 'save',
                isFreeAction: true,
                onClick: (evt, data) => {
                  addCategory(data);
                },
              },
            ]}
          />
          <BackButton />
          {/* <SaveChangeButton title="Save Changes" handle={saveChange}/> */}
        </div>
      )}
    </div>
  );
}
